import mutations from './user-mutations';
import * as actions from './user-actions';

export default {
  namespaced: true,
  state: {
    userData: {},
    peerData: {},
    userInfo: {},
    ipAddress: {},
    peerCSData: undefined,
    peerBdData: undefined,
    publicAuditData: {},
  },
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/user/user-store.js